import faker from 'faker'
import ranges from '@/constants/ranges'
import _ from 'lodash'

export const factoryModels = {
  Form: {
    id: faker.random.uuid(),
    title: faker.random.catch_phrase_descriptor,
    last_updated_at: faker.date.recent(),
    settings: {
      is_public: true,
      is_trial: false
    },
    self: {
      href: "https://api.typeform.com/forms/" + faker.random.uuid()
    },
    theme: {
      href: "https://api.typeform.com/themes/" + faker.random.uuid()
    },
    _links: {
      display: "https://developers3.typeform.com/to/" + faker.random.uuid()
    }
  },
  ClientBid: {
    id: _.random(0, 199),
    age: _.sample(ranges.age),
    sex: _.sample(['male', 'female', 'n/a', 'other']),
    yearsOfExp: _.random(1, 40),
    areasOfExpertise: ['Motor Vehichle Collision', 'Head Injury', 'Spinal'],
    spokenLanguages: ['English', 'French'],
    firmSize: _.sample(ranges.firmSize),
    location: 'London ON',
    costDetails: [
      {
        label: 'Pre-Discovery',
        amount: '20',
        rate: '%',
      },
      {
        label: 'Pre-Trial',
        amount: '20',
        rate: '%',
      },
      {
        label: 'Pre-Court Resolution',
        amount: '15',
        rate: '%',
      }
    ],
  },
  Lawyer: {
    password: faker.internet.password(),
    firstName: faker.name.firstName(),
    lastName: faker.name.lastName(),
    username: faker.internet.userName(),
    dateOfBirth: faker.date.past(20, '1990/03/03'),
    gender: _.sample(['female', 'male']),
    email: faker.internet.email(),
    verifyEmail: faker.internet.email(),
    countryCode: '+1',
    phone: faker.phone.phoneNumber(),
    lso: faker.random.number(),
    yearsOfExp: 12,
    areasOfExpertise: [],
    spokenLanguages: [],
    firmSize: 12,
  }
};
